import { render, staticRenderFns } from "./ObiSurveyQuestionCard.vue?vue&type=template&id=b166da70&scoped=true&"
import script from "./ObiSurveyQuestionCard.vue?vue&type=script&lang=js&"
export * from "./ObiSurveyQuestionCard.vue?vue&type=script&lang=js&"
import style0 from "./ObiSurveyQuestionCard.vue?vue&type=style&index=0&id=b166da70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b166da70",
  null
  
)

export default component.exports